module.exports = __webpack_public_path__ + "static/media/WELT POCKETS.ab2e74da.svg";